import React, { useState } from 'react'
import { MotionButton, MotionCard, MotionImage, MotionSection } from '../motion/Motion'

const faqs = [
  {
    question: 'What is your standard lead time for delivery in Zambia?',
    answer:
      'Our standard delivery time from final design approval is typically 3-4 weeks, significantly faster than the industry standard of 6-8 weeks for imported custom mats. We prioritize speed and efficiency through our dedicated logistics network.',
  },
  {
    question: 'Do you handle the customs and import duties (ZRA) documentation?',
    answer:
      'Yes. We can manage the full customs clearance process, including ZRA documentation, duties, and VAT where applicable. This removes the administrative burden from your team and helps ensure a smooth, delay-free delivery.',
  },
  {
    question: 'What file format do you need for my logo?',
    answer:
      'For best print quality we recommend vector files such as AI, EPS, or high-resolution PDF. We can also work with high-resolution PNG or JPG (300 dpi or higher). If you are unsure, send what you have and our team will advise.',
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept bank transfers in Zambian Kwacha (ZMW), mobile money, and selected card payments depending on your location. For corporate and institutional clients, we can also discuss approved credit terms subject to account opening.',
  },
]

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const handleToggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index))
  }

  return (
    <MotionSection className="w-[96%] mx-auto py-12 lg:py-16">
      <div className="grid gap-8 lg:gap-12 lg:grid-cols-2 items-stretch">
        {/* Image left */}
        <div className="w-full h-full hidden lg:block">
          <MotionImage className="w-full h-full">
            <img
              src="/images/sectionimages/FAQ.png"
              alt="FAQ illustration"
              className="w-full h-full object-cover rounded-2xl"
            />
          </MotionImage>
        </div>

        {/* FAQ content right */}
        <div className="flex flex-col h-full">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-6 max-w-xl">
            Get quick answers to the most common questions Zambian facility managers and marketing teams ask before
            ordering custom logo mats.
          </p>

          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index

              return (
                <MotionCard key={item.question} className="w-full" delay={0.03 * index}>
                  <button
                    type="button"
                    onClick={() => handleToggle(index)}
                    className="w-full text-left bg-white rounded-xl shadow-sm px-4 py-3 focus:outline-none focus:ring-2 focus:ring-pink-500/60 transition-colors"
                  >
                    <div className="flex items-start gap-3">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-pink-500 flex-shrink-0" />
                      <div className="flex-1">
                        <div className="flex items-start justify-between gap-3">
                          <p className="text-sm sm:text-base font-semibold text-gray-900">
                            <MotionButton>{item.question}</MotionButton>
                          </p>
                          <span className="text-pink-500 text-lg leading-none select-none">
                            {isOpen ? '-' : '+'}
                          </span>
                        </div>
                        {isOpen && item.answer && (
                          <p className="mt-2 text-[13px] sm:text-sm text-gray-700 leading-relaxed">{item.answer}</p>
                        )}
                      </div>
                    </div>
                  </button>
                </MotionCard>
              )
            })}
          </div>
        </div>
      </div>
    </MotionSection>
  )
}
